import React from 'react';
import {Link} from 'react-router';
import {observer, inject} from 'mobx-react';
import {IconButton, Drawer, TextField, CircularProgress, FlatButton, AutoComplete} from 'material-ui';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';
import MapPage from './Home/MapPage';
import {observable, action} from "mobx";
import {basinDisplayUrl, standardBasinOrder} from '../libs/config';
import {toJS} from "mobx";
import IGlass from 'material-ui/svg-icons/action/search';
import MapPageLeaflet from "./Home/MapPageLeaflet";

@inject('markerStore')
@observer
class Basin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      expandedBasin: {}
    }
  }

  @observable searchFilter = '';
  // @observable expandedBasin = {};
  @action onChangeSearchText = (value) => this.searchFilter = value && value.toLowerCase();
  @action onChangeSearchTextM = (e, value) => this.searchFilter = value && value.toLowerCase();

  sortBasin = basins => {
    const orderedBasin = [];
    // eslint-disable-next-line array-callback-return
    standardBasinOrder.map(basin => {
      let x = basins.filter(b => b.name.indexOf(basin) > -1)[0];
      if(x) orderedBasin.push(x);
    });
    return orderedBasin;
  };

  toggleOpen = () => this.setState({open: !this.state.open});
  toggleBasinExpand = (id) => {
    // this.expandedBasin[id] = !this.expandedBasin[id];
    this.setState({expandedBasin: Object.assign(this.state.expandedBasin, {[id]: !this.state.expandedBasin[id]})})
  }

  getFilteredFolderHierarchy(folderHier) {
    // const {markerStore} = this.props;
    // let groupedStations = _.groupBy(markerStore.getCombinedMarkers, item => item.folder);
    // let folderHier = Object.keys(groupedStations).map(folder => ({
    //   id: folder,
    //   name: folder,
    //   stations: groupedStations[folder]
    // }));

    if (!this.searchFilter) {
      return folderHier;
    }

    const foundFolders = folderHier.filter(folder => (
      folder.name.toLowerCase().indexOf(this.searchFilter) !== -1
    ));

    const foundFolderIds = foundFolders.map(folder => folder.id);

    const remainingFolders = folderHier
      .filter(folder => (
        foundFolderIds.indexOf(folder.id) === -1
      ));

    const remainingFoldersWithFoundStations = remainingFolders
      .map(folder => {
        const foundStations = folder.stations.filter(station => (
          (station &&
          station.name &&
          station.name.toLowerCase().indexOf(this.searchFilter) !== -1) ||

          (station &&
          station.tags &&
          station.tags.reduce((acc, tag) => {
            if (tag.name.toLowerCase().indexOf(this.searchFilter) !== -1) {
              return true;
            }
            return acc;
          }, false))
        ));

        return Object.assign({}, folder, {stations: foundStations});
      })
      .filter(folder => folder.stations.length > 0);

    return [
      ...foundFolders,
      ...remainingFoldersWithFoundStations,
    ];
  }

  getFilteredStations = (folderHierarchy) => {
    let filteredStations = [];
    // eslint-disable-next-line array-callback-return
    folderHierarchy.map(folder => {
      folder.stations.map(station => filteredStations.push(station));
    });
    return filteredStations;
  };

  onClickBasin = (basin) => {
    // console.log(`${basinDisplayUrl}/${basin.split(' ')[0]}Basin`);
    let hiddenElement = document.createElement('a');
    hiddenElement.href =  `${basinDisplayUrl}/${basin.split(' ')[0]}_Basin`;
    // hiddenElement.target = '_blank';
    hiddenElement.click();
  };


  render() {
    // if (folderStore.isLoading) return(<div className="spinner"><CircularProgress/></div>);
    const header = {
      background:'#0f72a9',
      padding:'10px',
      color:'white',
      justifyContent:'center',  
      alignContent:'center',
      alignItems:'center',
      marginBottom:'2px'
    };
    const {markerStore} = this.props;
    const filteredFolderHierarchy = this.getFilteredFolderHierarchy(markerStore.getFolderHierarchy);

    if (this.props.mobView) {
      return (
        <div className="map-page">
          <Drawer open={this.state.open} containerStyle={{width: '200px'}} docked={false} onRequestChange={this.toggleOpen} openSecondary={true}>
            <div style={header}><h3>Basins</h3></div>
            <div style={{padding:'10px'}}>
              <TextField
                className="basin-search"
                floatingLabelText="Search"
                value={this.searchFilter}
                onChange={this.onChangeSearchTextM}
                style={{width:'95%', marginTop:'-20px', marginBottom:'10px'}}
              />
              {this.sortBasin(filteredFolderHierarchy).map(folder => (
                <details key={folder.id} open>
                  <summary className='listSectionTitle'>
                    <a href={`${basinDisplayUrl}/${folder.name.replace(' ', '_')}_Basin`}>{folder.name ? folder.name : ' -- '}</a>
                  </summary>
                  <ul>
                    {folder && folder.stations && folder.stations.map(station => (
                      <li key={station.id}>
                        <Link className="basin-station" activeClassName='active-station' to={`/basin/${station.id}`} onClick={this.toggleOpen}>
                          <FlatButton style={{width:'100%', textAlign:'left', paddingLeft:'5px'}}>{station.name}</FlatButton>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </details>
              ))}
            </div>
          </Drawer>
          {this.props.children ?
            React.cloneElement(this.props.children, { mobView: true, toggleOpen: this.toggleOpen }) :
            <div>
              <IconButton className='pull-right' iconClassName='glyphicon glyphicon-menu-hamburger' onClick={this.toggleOpen}/>
              {/*<MapPage mobView filteredStations={this.getFilteredStations(filteredFolderHierarchy)} style={{width:"100%"}}/>*/}
              <MapPageLeaflet filteredStations={this.getFilteredStations(filteredFolderHierarchy)} style={{width:"100%"}}/>
            </div>}
        </div>
      );
    }
    else {
      return (
        <div className="col-md-12">
          <div className="col-md-2" style={{marginRight:'25px'}}>
            <div className='inline-it'>
              <IGlass style={{padding:'20px', marginRight:'10px', marginLeft:'-30px',color:'gray'}}/>
              <AutoComplete
                className="basin-search"
                type="search"
                dataSource={filteredFolderHierarchy.map(folder => folder.name)}
                searchText={this.searchFilter}
                floatingLabelText="Search"
                onUpdateInput={this.onChangeSearchText}
                filter={(searchText, key) => (key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1)}
                textFieldStyle={{width:'90%', marginTop:'-20px', marginBottom:'10px'}}
              />
            </div>
            <div className="FolderHierarchy">{
            this.sortBasin(filteredFolderHierarchy).map(folder => (
              <details key={folder.id}>
                <summary className='listSectionTitle'>
                  <ChevronRight style={{color: '#0f72a9', transform: !!this.state.expandedBasin[folder.id] ? 'rotate(90deg)' : 'rotate(0deg)'}} onClick={() => this.toggleBasinExpand(folder.id)}/>
                  <a style={{position: 'relative', bottom: '7px'}} href={`${basinDisplayUrl}/${folder.name.toLowerCase().indexOf('imja') > -1 ? 'IMJA' : folder.name.replace(' ', '_') + '_Basin'}`} target="_blank">{folder.name ? folder.name : ' -- '}</a>
                </summary>
                <ul>
                  {folder && folder.stations && folder.stations.map(station => (
                    <li key={station.id}>
                      <Link className="basin-station" activeClassName='active-station' to={`/basin/${station.id}`}>
                        <FlatButton style={{width:'100%', textAlign:'left', paddingLeft:'5px'}}>{station.name}</FlatButton>
                      </Link>
                    </li>
                  ))}
                </ul>
              </details>
            ))}
          </div>
          </div>

          <div className="col-md-9">
            {this.props.children ? this.props.children : <MapPageLeaflet filteredStations={this.getFilteredStations(filteredFolderHierarchy)} style={{width:"100%"}}/>}
          </div>
        </div>
      );
    }

  }
}

export default Basin;



// WEBPACK FOOTER //
// ./src/components/Basin.js